import React, { useState, useEffect } from 'react';
import './FloatingSupportButton.scss';
import TelegIcon from '../../../components/assets/images/logos_telegram.svg';   // укажите правильный путь
import WhatsUo from '../../../components/assets/images/WhatsupIconLogin.svg';    // укажите правильный путь

const FloatingSupportButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleGoToTelegram = () => {
    // Здесь можно добавить аналитику, например:
    // sendEvent('support_telegram_click');
    console.log('Telegram support clicked');
  };

  const handleGoToWhatsapp = () => {
    // Здесь можно добавить аналитику
    console.log('WhatsApp support clicked');
  };

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className={`floating-support ${isOpen ? 'open' : ''}`}>
      {isOpen && (
        <div className="floating-support__contact-list">
          <a
            href="https://t.me/tpobcn"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-item telegram"
            onClick={handleGoToTelegram}
          >
            <img src={TelegIcon} alt="Telegram" width={40} />
            <span>Telegram</span>
          </a>
          <a
            href="https://wa.me/34642868541"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-item whatsapp"
            onClick={handleGoToWhatsapp}
          >
            <img src={WhatsUo} alt="WhatsApp" width={48} />
            <span>WhatsApp</span>
          </a>
          <div className="contact-item phone">
            <div className="phone-numbers">
              <div>+34 642 868 541</div>
              <div>Soporte</div>
            </div>
          </div>
        </div>
      )}
      <button className="floating-support__toggle" onClick={toggleOpen}>
        {isOpen ? '✕' : '💬'}
      </button>
    </div>
  );
};

export default FloatingSupportButton;